import React, { Component } from "react"
import PropTypes from "prop-types"
import { OldButton } from "@kit/design/old-button"
import Stack from "@kit/design/stack"
import SelectMenu from "@kit/design/select-menu"

import { Input } from "core/deprecated-inputs"
import { CheckboxField, Field } from "core/form"
import { CustomFieldSelect, TagSelect } from "app/shared/selects"

export const SaveAs = {
  Custom: "Custom Field",
  Tag: "Tag"
}

export const FieldType = {
  Dropdown: "Dropdown",
  Checkboxes: "Checkboxes"
}

const change = ({ save_as, field_type, tags, ...rest }) => {
  switch (save_as) {
    case SaveAs.Custom:
      return { save_as, field_type: null, ...rest }
    case SaveAs.Tag:
      return {
        save_as,
        field_type: field_type || FieldType.Dropdown,
        tags,
        ...rest
      }
    default:
      return { save_as, field_type, ...rest }
  }
}

export class CustomFieldSettings extends Component {
  static title = "Custom Field"

  static propTypes = {
    element: PropTypes.object,
    onChange: PropTypes.func,
    onRemove: PropTypes.func
  }

  updateElement = attrs => {
    const element = this.props.element
    this.props.onChange(change({ ...element, ...attrs }))
  }

  handleChange = event => {
    const { name, value } = event.target

    this.updateElement({ [name]: value })
  }

  handleRemove = () => {
    this.props.onRemove({ name: this.props.element.name })
  }

  handleCustomFieldChange = event => {
    const customField = event.target.value

    this.updateElement({
      custom_field_key: customField.key,
      custom_field_label: customField.label,
      label: customField.label
    })
  }

  handleTagChange = event => {
    const tags = event.target.value.map(tag =>
      tag.display_label ? tag : { ...tag, display_label: tag.label }
    )

    this.updateElement({ tags })
  }

  handleTagLabelChange = event => {
    const tagId = event.target.name
    const display_label = event.target.value || ""

    const tags = this.props.element.tags.map(tag =>
      tag.value == tagId ? { ...tag, display_label } : tag
    )

    this.updateElement({ tags })
  }

  handleRequiredChange = event => {
    this.updateElement({ required: event.target.checked })
  }

  render() {
    const {
      label,
      custom_field_label,
      save_as = SaveAs.Custom,
      field_type,
      tags,
      required
    } = this.props.element

    const customField = custom_field_label
      ? { label: custom_field_label }
      : null

    return (
      <div className="w-full mb-6">
        <Stack spacing={2}>
          <Field
            control={SelectMenu}
            label="Save as"
            name="save_as"
            options={[
              { label: "Custom Field", value: "Custom Field" },
              { label: "Tag", value: "Tag" }
            ]}
            span={save_as == SaveAs.Custom ? 12 : 5}
            value={save_as}
            onChange={this.handleChange}
            controlClassName="relative w-full"
          />
          {save_as == SaveAs.Custom ? (
            <Stack spacing={2}>
              <Field
                control={CustomFieldSelect}
                label="Custom field"
                name="custom_field"
                onChange={this.handleCustomFieldChange}
                span={12}
                value={customField}
                additionalOptions={[
                  {
                    label: "First Name",
                    key: "first_name",
                    value: "first_name"
                  }
                ]}
              />
              <Field
                control={Input}
                label="Custom field label"
                name="label"
                span={12}
                value={label || ""}
                onChange={this.handleChange}
                disabled={!custom_field_label}
                controlClassName="ck-input"
              />
            </Stack>
          ) : (
            <Stack spacing={2}>
              <Field
                control={SelectMenu}
                label="Field type"
                name="field_type"
                options={[
                  { label: "Dropdown", value: "Dropdown" },
                  { label: "Checkboxes", value: "Checkboxes" }
                ]}
                span={7}
                value={field_type}
                onChange={this.handleChange}
                controlClassName="relative w-full"
              />
              <Field
                control={Input}
                label="Label"
                name="label"
                span={12}
                value={label || ""}
                onChange={this.handleChange}
                controlClassName="ck-input"
              />
              <Field
                control={TagSelect}
                label="Tag options"
                name="tags"
                onChange={this.handleTagChange}
                span={12}
                value={tags}
              />
              {tags &&
                tags.map(tag => (
                  <Field
                    control={Input}
                    label={`Label for ${tag.label}`}
                    key={tag.value}
                    name={tag.value}
                    onChange={this.handleTagLabelChange}
                    value={tag.display_label}
                    controlClassName="ck-input"
                  />
                ))}
            </Stack>
          )}
          {field_type != FieldType.Checkboxes && (
            <CheckboxField
              label="Required"
              name="required"
              onChange={this.handleRequiredChange}
              span={12}
              checked={required || false}
            />
          )}
          <OldButton is="secondary" icon="delete" onClick={this.handleRemove}>
            Delete field
          </OldButton>
          <OldButton
            href="https://help.kit.com/en/articles/4000470-how-to-add-custom-fields-to-forms-landing-pages"
            className="text-blue-500 focus:text-blue-800 hover:text-blue-800 flex items-center"
            target="_blank"
            rel="noopener noreferrer"
            icon="information-circle"
          >
            Learn about custom fields
          </OldButton>
        </Stack>
      </div>
    )
  }
}
